import { render, staticRenderFns } from "./online-insurance.vue?vue&type=template&id=155348fe&scoped=true&"
import script from "./online-insurance.vue?vue&type=script&lang=js&"
export * from "./online-insurance.vue?vue&type=script&lang=js&"
import style0 from "./online-insurance.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./online-insurance.vue?vue&type=style&index=1&id=155348fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155348fe",
  null
  
)

export default component.exports